//Library Imports
import store from "store";

//Local Imports
import {
  CAMPAIGN_AUDIENCE,
  ASSET_AUDIENCE,
  PEOPLE_AUDIENCE,
  AUDIENCE_CONTACT_DETAILS,
  AUDIENCE_CONTACT_DASHBOARD,
  AUDIENCE_CONTACT_SUBSCRIPTIONS,
  AUDIENCE_CONTACT_ENGAGEMENT,
  AUDIENCE_CONTACT_SIMILAR,
  AUDIENCE_ADD_LIST_CONTACT,
  AUDIENCE_DELETE_CAMPAIGN_CONTACT,
  AUDIENCE_DELETE_ASSET_CONTACT,
  AUDIENCE_REMOVE_RECOMMENDED,
  AUDIENCE_REMOVE_SUBSCRIBED,
  SUGGESTED_EMAILS,
  VIEW_RECIPIENTS,
  AUDIENCE_PEOPLE,
} from "constants/actionTypes";
import {
  linkAudienceWithCampaignService,
  getListForAssetService,
  getContactsForAssetService,
  linkAudienceWithAssetService,
  getListofProfiledPeopleService,
  getContactDetailsService,
  getContactDashboardService,
  getContactSubscriptionsService,
  createNewContactAudienceService,
  getContactEngagementService,
  getContactSimilarService,
  deletePeopleinAudience,
  deleteCampaignAudienceService,
  deleteAssetAudienceService,
  addListContactService,
  searchContactsService,
  importListService,
  importListProgressService,
  searchListContactService,
  activeInactiveListContactService,
  getAudienceAllPeopleListService,
  updateContactService,
  getOrganizationsService,
  getDesignationsService,
} from "modules/Services/AudienceService";
import { closeCreateNewContactSidebar, closeOverlay } from "modules/GlobalActions";
import { serializeContacts, serializeList, serializeCreateContact } from "./utils";
import { getRecommendedPeople, resetRecommendedContacts } from "../CampaignAssets/actions";
import {
  resetAudienceLists,
  updateListContactsCount,
  resetAudienceListDetails,
  reloadListDetails,
} from "./Lists/actions";
import { setCampaignAudienceListSelected } from "modules/OnBoarding/actions";
import { IActiveInactiveListContact, ISearchListContacts } from "./interface";
import {
  AUDIENCE_LISTS,
  AUDIENCE_LISTS_CONTACTS_EDIT,
  AUDIENCE_LISTS_DETAILS,
  AUDIENCE_LISTS_NAME_EDIT,
  CAMPAIGNS_LIST,
  AUDIENCE_LISTS_PROFILED_CONTACTS,
} from "constants/types";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import { getQueryListId } from "utils";

export const searchContactsAPI = (
  campaignId: number,
  searchValue: string,
  isAsset: boolean,
  isRecipient: boolean,
  offset: number,
  limit: number
) => {
  store.dispatch({
    type: CAMPAIGN_AUDIENCE.CONTACTS_LOAD,
  });
  if (isAsset) {
    store.dispatch({
      type: ASSET_AUDIENCE.CONTACTS_LOAD,
    });
  }

  searchContactsService(campaignId, searchValue, isAsset, offset, limit)
    .then((res: any) => {
      if (!res.data.message) {
        if (isAsset) {
          let serializedContacts = serializeContacts(res.data);

          if (isRecipient) {
            store.dispatch({
              type: ASSET_AUDIENCE.RECIPIENT_SEARCH_SUCCESS,
              payload: { contacts: serializedContacts },
            });
            if (searchValue === "") {
              store.dispatch({
                type: VIEW_RECIPIENTS.SET_IS_SEARCH,
                payload: false,
              });
            } else {
              store.dispatch({
                type: VIEW_RECIPIENTS.SET_IS_SEARCH,
                payload: true,
              });
            }
          } else {
            store.dispatch({
              type: ASSET_AUDIENCE.CONTACTS_SEARCH_SUCCESS,
              payload: { contacts: serializedContacts },
            });
          }
        } else {
          let serializedContacts = serializeContacts(res.data);
          store.dispatch({
            type: CAMPAIGN_AUDIENCE.CONTACTS_SUCCESS,
            payload: { contacts: serializedContacts },
          });
        }
      } else {
        // α case in search
        store.dispatch({
          type: ASSET_AUDIENCE.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: ASSET_AUDIENCE.ERROR_SEARCH_TERM_LOADING,
        });
        store.dispatch({ type: VIEW_RECIPIENTS.SET_IS_SEARCH, payload: true });
      }
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: CAMPAIGN_AUDIENCE.LISTS_FAIL,
        payload: [],
      });
    });
};

export const linkAudienceWithCampaign = (
  campaignId: number,
  listIds: number[],
  contactIds: number[],
  index?: number
) => {
  store.dispatch({
    type: CAMPAIGN_AUDIENCE.LISTS_LOAD,
  });

  linkAudienceWithCampaignService(campaignId, listIds, contactIds)
    .then((res: any) => {
      let serializedContacts = serializeContacts(res.data.contact_objs);
      let serializedLists = serializeList(res.data.list_objs);
      store.dispatch({
        type: CAMPAIGN_AUDIENCE.LINK_AUDIENCE_CAMPAIGN_SUCCESS,
        payload: { lists: serializedLists, contacts: serializedContacts },
      });

      if (res.data.success && index) {
        getContactSubscriptions(contactIds.toString());
        store.dispatch({
          type: AUDIENCE_REMOVE_RECOMMENDED.CAMPAIGN,
          payload: index,
        });
      }
      closeOverlay();
    })
    .catch((err: any) => {
      console.log(err);
      // store.dispatch({
      //   type: AUDIENCE.LOAD_FAIL,
      //   payload: [],
      // });
    });
};

export const setupListForOnBoarding = () => {
  const onBoardingRecommendedLists = [
    {
      id: 7321,
      name: "Dummy List",
      topContactsThumbnail: [
        "https://media.swncdn.com/cms/CW/Couples/singles/31014-singleman-youngman-man-backpack-hiking.1200w.tn.jpg",
        "https://amansquest.com/wp-content/uploads/2017/09/single-men-portrait-smiling-young-man-standing-by-ss.jpg",
        "https://www.biography.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cg_face%2Cq_auto:good%2Cw_300/MTc5ODc1NTM4NjMyOTc2Mzcz/gettyimages-693134468.jpg",
        "https://knowinsiders.com/stores/news_dataimages/linhtd/022021/24/14/1540_10-most-handsome-men-in-us.jpg",
      ],
      totalContacts: 4,
      totalSent: 0,
      totalClicks: 0,
      count: 1,
    },
  ];

  store.dispatch({
    type: CAMPAIGN_AUDIENCE.LISTS_LOAD,
  });

  store.dispatch({
    type: CAMPAIGN_AUDIENCE.SET_LIST,
    payload: { lists: onBoardingRecommendedLists },
  });
  setCampaignAudienceListSelected(true);
};

export const linkAudienceWithAsset = (
  assetId: number,
  listIds: number[],
  contactIds: number[],
  index?: number,
  fromRecommended?: boolean,
  campaignsLength?: number
) => {
  linkAudienceWithAssetService(assetId, listIds, contactIds)
    .then((res: any) => {
      if (res.data.success) {
        if (fromRecommended) {
          getContactSubscriptions(contactIds.toString());
          if (campaignsLength === 1) getContactDashboard(contactIds.toString());
          store.dispatch({
            type: AUDIENCE_REMOVE_RECOMMENDED.ASSET,
            payload: index,
          });
        }

        if (!fromRecommended) {
          let serializedContacts = serializeContacts(res.data.contact_objs);
          store.dispatch({
            type: ASSET_AUDIENCE.CONTACTS_SUCCESS,
            payload: { contacts: serializedContacts },
          });
          closeOverlay();
        }
        store.dispatch({
          type: CAMPAIGNS_LIST.UPDATE_AUDIENCE_COUNT,
          audience: res.data.contact_objs.length + res.data.list_objs.length,
          campaign_id: assetId,
        });
      }
      getListForAsset(assetId);
    })
    .catch((err: any) => {
      console.log(err);
    });
};

export const getListForAsset = (assetId: number) => {
  store.dispatch({
    type: ASSET_AUDIENCE.LISTS_LOAD,
  });

  getListForAssetService(assetId)
    .then((res: any) => {
      let serializedLists = serializeList(res.data);
      store.dispatch({
        type: ASSET_AUDIENCE.LISTS_SUCCESS,
        payload: { lists: serializedLists },
      });
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: ASSET_AUDIENCE.LISTS_FAIL,
        payload: { lists: [] },
      });
    });
};

export const getContactsForAsset = (
  sort_by: string,
  sort_type: string,
  assetId: number,
  offset = 0,
  limit = 20,
  searchTerm = "",
  reset = false,
  publishPage = false,
  active_count?: boolean
) => {
  store.dispatch({
    type: ASSET_AUDIENCE.CONTACTS_LOAD,
    reset: reset,
  });

  getContactsForAssetService(assetId, offset, limit, searchTerm, publishPage, sort_by, sort_type, active_count)
    .then((res: any) => {
      if (!res.data.message) {
        let serializedContacts = serializeContacts(res.data);
        store.dispatch({
          type: ASSET_AUDIENCE.CONTACTS_SUCCESS,
          payload: { contacts: serializedContacts },
        });
      } else {
        // α case in search
        store.dispatch({
          type: ASSET_AUDIENCE.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: ASSET_AUDIENCE.ERROR_SEARCH_TERM_LOADING,
        });
      }
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: ASSET_AUDIENCE.CONTACTS_FAIL,
        payload: { contacts: [] },
      });
    });
};

export const getAudienceAllPeopleList = (
  limit: number,
  offset: number,
  tabState: string,
  searchTerm: string,
  filter_by_organization: string[],
  filter_by_designation: string[],
  personality_type: string[],
  filter_by_status: string[],
  sort_by: string,
  sort_type: string,
  email_id: string,
  uuid: string
) => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.LISTS_LOAD_ALL_PEOPLE,
  });
  if (searchTerm !== undefined && searchTerm !== "") {
    getAudienceAllPeopleListService(
      limit,
      offset,
      tabState,
      searchTerm,
      filter_by_organization,
      filter_by_designation,
      personality_type,
      filter_by_status,
      sort_by,
      sort_type,
      email_id,
      uuid
    )
      .then((res: any) => {
        if (!res.data.message) {
          store.dispatch({
            type: PEOPLE_AUDIENCE.LISTS_SUCCESS_ALL_PEOPLE_SEARCH,
            payload: res.data.people_details_list,
            totalCount: res.data.total_contacts,
          });
        } else {
          // α case in search
          store.dispatch({
            type: PEOPLE_AUDIENCE.ERROR_SEARCH_TERM,
            payload: { message: res.data.message, success: false },
          });
          store.dispatch({
            type: PEOPLE_AUDIENCE.ERROR_SEARCH_TERM_LOADING,
          });
        }
      })
      .catch((err: any) => {
        console.log(err);
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_FAIL_ALL_PEOPLE,
          message: err.message,
        });
      });
  } else {
    getAudienceAllPeopleListService(
      limit,
      offset,
      tabState,
      searchTerm,
      filter_by_organization,
      filter_by_designation,
      personality_type,
      filter_by_status,
      sort_by,
      sort_type,
      email_id,
      uuid
    )
      .then((res: any) => {
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_SUCCESS_ALL_PEOPLE,
          payload: res.data.people_details_list,
          totalCount: res.data.total_contacts,
        });
      })
      .catch((err: any) => {
        console.log(err);
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_FAIL_ALL_PEOPLE,
          message: err.message,
        });
      });
  }
};

export const getAudienceProfiledPeopleList = (
  limit: number,
  offset: number,
  tabState: string,
  searchTerm: string,
  filter_by_organization: string[],
  filter_by_designation: string[],
  personality_type: string[],
  filter_by_status: string[]
) => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.LISTS_LOAD_PROFILED,
  });
  if (searchTerm !== undefined && searchTerm !== "") {
    getListofProfiledPeopleService(
      limit,
      offset,
      tabState,
      searchTerm,
      filter_by_organization,
      filter_by_designation,
      personality_type,
      filter_by_status
    )
      .then((res: any) => {
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_SUCCESS_PROFILED_SEARCH,
          payload: res.data.people_details_list,
          totalCount: res.data.total_contacts,
        });
      })
      .catch((err: any) => {
        console.log(err);
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_FAIL_PROFILED,
          message: err.message,
        });
      });
  } else {
    getListofProfiledPeopleService(
      limit,
      offset,
      tabState,
      searchTerm,
      filter_by_organization,
      filter_by_designation,
      personality_type,
      filter_by_status
    )
      .then((res: any) => {
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_SUCCESS_PROFILED,
          payload: res.data.people_details_list,
          totalCount: res.data.total_contacts,
        });
      })
      .catch((err: any) => {
        console.log(err);
        store.dispatch({
          type: PEOPLE_AUDIENCE.LISTS_FAIL_PROFILED,
          message: err.message,
        });
      });
  }
};

export const getContactDetails = (contactId: string) => {
  store.dispatch({
    type: AUDIENCE_CONTACT_DETAILS.LOAD,
    payload: { loading: true },
  });
  getContactDetailsService(contactId)
    .then((res) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_DETAILS.SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_DETAILS.FAIL,
        payload: {},
      });
    });
};

export const getContactDashboard = (contactId: string) => {
  store.dispatch({
    type: AUDIENCE_CONTACT_DASHBOARD.LOAD,
    payload: { loading: true },
  });
  getContactDashboardService(contactId)
    .then((res) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_DASHBOARD.SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_DASHBOARD.FAIL,
        payload: {},
      });
    });
};

export const getContactSubscriptions = (contactId: string) => {
  store.dispatch({
    type: AUDIENCE_CONTACT_SUBSCRIPTIONS.LOAD,
    payload: { loading: true },
  });
  if (contactId !== "") {
    getContactSubscriptionsService(contactId)
      .then((res) => {
        store.dispatch({
          type: AUDIENCE_CONTACT_SUBSCRIPTIONS.SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        store.dispatch({
          type: AUDIENCE_CONTACT_SUBSCRIPTIONS.FAIL,
          payload: { loading: false },
        });
      });
  }
};
export const createNewContactAudience = (
  form: any,
  selectedTab: string,
  audienceFiltersApplied: boolean,
  searchTermPeople?: string,
  searchTermListDetails?: string
) => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_LOAD,
  });
  store.dispatch({
    type: AUDIENCE_LISTS_PROFILED_CONTACTS.LOAD,
  });
  createNewContactAudienceService(form)
    .then((res: any) => {
      if (
        res.data && // if response is not empty
        !audienceFiltersApplied // if no filters are applied
      ) {
        console.log("no filters applied: ", res.data);
        store.dispatch({
          type: AUDIENCE_LISTS_PROFILED_CONTACTS.FAIL,
        });
        // if no filters are applied and no contacts are searched, then further logic will run
        store.dispatch({
          type: AUDIENCE_PEOPLE.ORGANIZATIONS_UPDATE,
          organization: { name: res.data?.contact_details?.organization },
        });
        if (res.data?.contact_details?.designation.trim().length > 0) {
          store.dispatch({
            type: AUDIENCE_PEOPLE.DESIGNATIONS_UPDATE,
            designation: { name: res.data?.contact_details?.designation },
          });
        }
        if (form.listId) {
          if (res.data.contact_details.already_exists_in_list) {
            store.dispatch({
              type: AUDIENCE_LISTS_DETAILS.CONTACT_UPDATED_SUCCESS,
            });
          } else {
            if (searchTermListDetails?.length === 0) {
              let serializedContacts = serializeCreateContact(res.data.contact_details);
              store.dispatch({
                type: AUDIENCE_LISTS_DETAILS.ADD_NEW_CONTACT,
                createdContact: serializedContacts,
                selectedTab: selectedTab,
              });
            } else {
              reloadListDetails(true, "profiled"); // set true to call contacts api in ProfiledList.tsx
            }
          }
          store.dispatch({
            type: PEOPLE_AUDIENCE.RESET_CREATE_CONTACT_LOADER,
          });
          store.dispatch({
            type: AUDIENCE_LISTS.DISABLE_EXPORT_LOADER,
          });
          setTimeout(function () {
            let { showCreateContactForm } = store.getState().audience;
            // if user immediately click on the overlay to open the contact detail then the following code
            // should not run.
            if (showCreateContactForm) closeCreateNewContactSidebar();
            createNewContactResetFormAudience();
          }, 3000);
        } else {
          // if (searchTermPeople?.length === 0) {
          // } else {
          if (res.data.contact_updated) {
            store.dispatch({
              type: PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_UPDATE_SUCCESS,
              payload: {
                updatedContact: res.data.contact_details,
                profiled: selectedTab,
                isProfiled: res.data.profiled,
              },
            });
            resetAudienceListDetails(); // in case when a user is updated the recent list details data will be removed from store.
          } else {
            store.dispatch({
              type: PEOPLE_AUDIENCE.UPDATE_TOTAL_COUNT_ON_CREATE_CONTACT,
            });
            store.dispatch({
              type: PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_LOAD_SUCCESS,
              payload: {
                newContact: res.data.contact_details,
                profiled: selectedTab,
                isProfiled: res.data.profiled,
              },
            });
          }
          resetRecommendedContacts();
          getRecommendedPeople();
          setTimeout(function () {
            let { showCreateContactForm } = store.getState().audience;
            // if user immediately click on the overlay to open the contact detail then the following code
            // should not run.
            if (showCreateContactForm) closeCreateNewContactSidebar();
            createNewContactResetFormAudience();
          }, 3000);
        }
        // }
        updateListContactsCount(getQueryListId(), 1, true);
      }
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_LOAD_FAIL,
        payload: {},
      });
    });
};

export const updateContact = (form: any, contactId: string, addOrganization: boolean, addDesignation: boolean) => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.UPDATE_CONTACT_CALL_IN_PROGRESS,
  });
  updateContactService(form, contactId)
    .then((res) => {
      if (res.data.success) {
        if (addOrganization) {
          store.dispatch({
            type: AUDIENCE_PEOPLE.ORGANIZATIONS_UPDATE,
            organization: { name: res.data.updated_contact_details.organization },
          });
        }
        if (addDesignation) {
          store.dispatch({
            type: AUDIENCE_PEOPLE.DESIGNATIONS_UPDATE,
            designation: { name: res.data.updated_contact_details.designation },
          });
        }
        store.dispatch({
          type: PEOPLE_AUDIENCE.UPDATE_CONTACT_SUCCESS,
          payload: res.data.updated_contact_details,
        });
        store.dispatch({
          type: AUDIENCE_LISTS_CONTACTS_EDIT.SUCCESS,
          updateContact: res.data.updated_contact_details,
        });
        store.dispatch({
          type: AUDIENCE_LISTS_NAME_EDIT.UPDATE_LAST,
          listId: getQueryListId(),
        });
        store.dispatch({
          type: ASSET_AUDIENCE.UPDATE_CONTACT_SUCCESS,
          updateContact: res.data.updated_contact_details,
        });
        // reducer will update the contact details in the store.
        getContactDetails(contactId);
      }
    })
    .catch((err) => {
      store.dispatch({
        type: PEOPLE_AUDIENCE.UPDATE_CONTACT_FAIL,
      });
    });
};

export const getContactEngagement = (contactId: string) => {
  store.dispatch({
    type: AUDIENCE_CONTACT_ENGAGEMENT.LOAD,
    payload: { loading: true },
  });
  getContactEngagementService(contactId)
    .then((res) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_ENGAGEMENT.SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_ENGAGEMENT.FAIL,
        payload: {},
      });
    });
};

export const getContactSimilar = (contactId: string) => {
  store.dispatch({
    type: AUDIENCE_CONTACT_SIMILAR.LOAD,
    payload: { loading: true },
  });
  getContactSimilarService(contactId)
    .then((res) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_SIMILAR.SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_CONTACT_SIMILAR.FAIL,
        payload: {},
      });
    });
};
export const createNewContactResetFormAudience = () => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.CREATE_NEW_CONTACT_RESET_FORM,
  });
};

export const deleteSelectedContactAudience = (
  selectedIds: any,
  tab: string,
  deleteAll: boolean,
  unselectedIds?: any,
  isSearch?: string,
  selectedOrganization?: string[],
  selectedDesignation?: string[],
  selectedPersonalityType?: string[],
  selectedStatus?: string[]
) => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_LOAD,
  });
  deletePeopleinAudience(
    selectedIds,
    deleteAll,
    unselectedIds && unselectedIds,
    tab,
    isSearch,
    selectedOrganization,
    selectedDesignation,
    selectedPersonalityType,
    selectedStatus
  )
    .then((res: any) => {
      if (res.data.success) {
        reloadListDetails(true, tab);
        if (deleteAll) {
          store.dispatch({
            type: PEOPLE_AUDIENCE.DELETE_ALL_SELECTED_CONTACT_SUCCESS,
            payload: { unselectedIds, tab },
          });
        } else {
          store.dispatch({
            type: PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_SUCCESS,
            payload: { selectedIds, tab },
          });
        }
        if (deleteAll && unselectedIds.length > 0) {
          store.dispatch({
            type: PEOPLE_AUDIENCE.TOTAL_COUNT_UPDATE_ON_DELETE_ALL,
            payload: { tab: tab, unselectedIds: unselectedIds.length },
          });
        }
        setTimeout(() => {
          store.dispatch({
            type: PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_RESET,
          });
        }, 3000);
        resetRecommendedContacts();
        getRecommendedPeople();
        resetAudienceLists();
      } else {
        store.dispatch({
          type: PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_FAIL,
        });
      }
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: PEOPLE_AUDIENCE.DELETE_SELECTED_CONTACT_FAIL,
      });
    });
};

export const deleteCampaignAudience = (listIds: any, contactIds: any, campaignId: string, index?: number) => {
  store.dispatch({
    type: AUDIENCE_DELETE_CAMPAIGN_CONTACT.LOAD,
    payload: { loading: true },
  });
  deleteCampaignAudienceService(listIds, contactIds, campaignId)
    .then((res) => {
      store.dispatch({
        type: AUDIENCE_DELETE_CAMPAIGN_CONTACT.SUCCESS,
        payload: res.data,
      });
      if (res.data.success) {
        store.dispatch({
          type: AUDIENCE_REMOVE_SUBSCRIBED.CAMPAIGN,
          payload: index,
        });
      }
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_DELETE_CAMPAIGN_CONTACT.FAIL,
        payload: {},
      });
    });
};

export const deleteAssetAudience = (listIds: any, contactIds: any, assetId: string, index?: number) => {
  store.dispatch({
    type: AUDIENCE_DELETE_ASSET_CONTACT.LOAD,
    payload: { loading: true },
  });
  deleteAssetAudienceService(listIds, contactIds, assetId)
    .then((res) => {
      if (res.data.success) {
        getContactDashboard(contactIds.toString()); // what if multiple contacts are deleted?
        store.dispatch({
          type: AUDIENCE_REMOVE_SUBSCRIBED.CAMPAIGN,
          payload: index,
        });
        if (assetId === getQueryCampaignId().toString()) {
          store.dispatch({
            type: ASSET_AUDIENCE.REMOVE_CONTACT_SUCCESS,
            payload: contactIds[0],
          });
        }
      }
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_DELETE_ASSET_CONTACT.FAIL,
        payload: {},
      });
    });
};

export const addListContact = (
  listId: string,
  contactId: string,
  index?: number,
  fromRecommended?: boolean,
  listsLength?: number
) => {
  store.dispatch({
    type: AUDIENCE_ADD_LIST_CONTACT.LOAD,
    payload: { loading: true },
  });
  addListContactService(listId, contactId)
    .then((res) => {
      if (fromRecommended) {
        getContactSubscriptions(contactId.toString());
        if (listsLength === 1) getContactDashboard(contactId.toString());
        store.dispatch({
          type: AUDIENCE_REMOVE_RECOMMENDED.LIST,
          payload: index,
        });
        updateListContactsCount(listId, 1, true);
      }
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_ADD_LIST_CONTACT.FAIL,
        payload: {},
      });
    });
};

export const importList = (listName: string, mappings: string, selectedFile: File) => {
  return importListService(listName, mappings, selectedFile);
};

export const importListProgress = (list_id: number) => {
  return importListProgressService(list_id);
};

export const searchListContacts = async (searchTerm: string, params?: ISearchListContacts) => {
  store.dispatch({ type: SUGGESTED_EMAILS.LOAD, payload: true });
  return await searchListContactService(searchTerm, params).then((res) => {
    if (!res.data.message) {
      let contactsData = res.data;
      if (params) {
        const { alreadySelectedContactsIds } = params;
        if (alreadySelectedContactsIds.length > 0) {
          contactsData = res.data.filter(
            (contact: any) => !alreadySelectedContactsIds.includes(contact.contact_id)
          );
        }
      }
      store.dispatch({ type: SUGGESTED_EMAILS.SUCCESS, payload: contactsData });
    } else {
      store.dispatch({
        type: SUGGESTED_EMAILS.ERROR_SEARCH_TERM,
        payload: { message: res.data.message },
      });
    }
  });
};

export const removeProfiledFromUnprofiledAction = () => {
  store.dispatch({ type: PEOPLE_AUDIENCE.LISTS_REMOVE_PROFILED_FROM_UNPROFILED });
};

export const removeUnprofiledFromProfiledAction = () => {
  store.dispatch({ type: PEOPLE_AUDIENCE.LISTS_REMOVE_UNPROFILED_FROM_PROFILED });
};

export const setAudiencePeopleSearchTerm = (value: string) => {
  store.dispatch({ type: AUDIENCE_PEOPLE.SEARCH, payload: value });
};

export const getOrganizations = (listId?: string, search?: string) => {
  store.dispatch({ type: AUDIENCE_PEOPLE.LOADING_ORGANIZATIONS });
  getOrganizationsService(listId, search)
    .then((res: any) => {
      store.dispatch({ type: AUDIENCE_PEOPLE.ORGANIZATIONS, payload: res.data.data });
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_PEOPLE.ORGANIZATIONS_FAIL,
      });
    });
};

export const getDesignations = (listId?: string, search?: string) => {
  store.dispatch({ type: AUDIENCE_PEOPLE.LOADING_DESIGNATIONS });
  getDesignationsService(listId, search)
    .then((res: any) => {
      store.dispatch({ type: AUDIENCE_PEOPLE.DESIGNATIONS, payload: res.data.data });
    })
    .catch((err) => {
      store.dispatch({
        type: AUDIENCE_PEOPLE.DESIGNATIONS_FAIL,
      });
    });
};

export const updateCampaignRecipientState = (
  campaignId: string,
  updatedListsState: any[],
  updatedContactsState: any[],
  updatedListObject: any[],
  updatedContactObject: any[]
) => {
  const updatedRecipientLists = updatedListsState.map((list: any) => {
    return {
      list_id: list.id,
      is_active: list.is_active,
    };
  });

  const updatedRecipientContacts = updatedContactsState.map((contact: any) => {
    return {
      contact_id: contact.id,
      is_active: contact?.status === "Subscribed" ? contact.is_active : 0,
    };
  });

  const updatedListObjectArray = updatedListObject.map((list) => {
    return {
      list_id: list.id,
      is_active: list.is_active,
    };
  });

  const updatedContactObjectArray = updatedContactObject.map((contact) => {
    return {
      contact_id: contact.id,
      is_active: contact.is_active,
    };
  });

  if (updatedRecipientLists.length > 0 || updatedRecipientContacts.length > 0) {
    store.dispatch({ type: VIEW_RECIPIENTS.LOAD });
    activeInactiveListContactService(campaignId, updatedListObjectArray, updatedContactObjectArray)
      .then((res) => {
        if (res.data.success) {
          store.dispatch({
            type: ASSET_AUDIENCE.LISTS_RECIPIENT_STATE_UPDATE,
            updatedRecipientListsState: updatedListsState,
          });
          store.dispatch({
            type: ASSET_AUDIENCE.CONTACTS_RECIPIENT_STATE_UPDATE,
            updatedRecipientContactsState: updatedContactsState,
          });
          store.dispatch({ type: VIEW_RECIPIENTS.SUCCESS, payload: res.data.total_recipients });
        } else {
          store.dispatch({ type: VIEW_RECIPIENTS.FAIL });
        }
      })
      .catch((err) => {
        store.dispatch({ type: VIEW_RECIPIENTS.FAIL });
        console.log(err);
      });
  }
};
